var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.compitions),function(game){return _c('div',{key:game._id},[_c('v-list-item',{key:game.name,attrs:{"id":game.name,"to":{
                name: 'sportsbook-category-subCategory',
                params: { category: _vm.gameName, subCategory: game._id },
                query: { tabIdx: _vm.tabIdx }
            },"dense":""}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("\n                    "+_vm._s(game.name)+"\n                ")])],1)],1),_vm._v(" "),_c('v-divider',{key:'divider' + game.name})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }